import React, { useState, useEffect } from 'react';
import { notification } from 'antd';
import Success from "../../assets/Success.svg";  // Adjust path accordingly
import Exportfail from "../../assets/Export fail.svg";  // Adjust path accordingly

const ToastNotification = ({ type, message, description, duration, setShowNotification, icon, style }) => {
  const [notificationStyle, setNotificationStyle] = useState({
    backgroundColor:type==='success'?'#DCF5E6':'#FFECE0',
    color: 'black',
    padding: '10px 20px',
    borderRadius: '8px',
    fontSize: '16px',
    boxSizing: 'border-box',
    width: '81.9vw',  // Default width for larger screens
    height: '90px', 
  });
    const customClassName = style?.className || '';
    const screenWidth = window.innerWidth; // Get current screen width
    //console.log('Window resized to: ', screenWidth); // Debug: log the screen width

    let newNotificationStyle = {
      ...notificationStyle,
    };
    if (screenWidth <= 480) {
      newNotificationStyle = {
        ...newNotificationStyle,
        width: '70vw',  // Set width to 90% of the viewport width for small screens
      };
    } else if (screenWidth <= 768) {
      newNotificationStyle = {
        ...newNotificationStyle,
        width: '75vw',  // Set width to 80% of the viewport width for medium screens
      };
    } else {
      newNotificationStyle = {
        ...newNotificationStyle,
        width: '81.9vw',  // Set width to 81.9% of the viewport width for larger screens
      };
    }
  const notificationConfig = {
    message: (
      <h5>
        <img
          style={{ marginTop: -4, marginLeft: -30, marginRight: 10 }}
          width="20px"
          height="20px"
          src={type === 'success' ? Success : Exportfail}
          alt={type}
        />
       <span className={"font-face-vzb page-sub-heading-user"}>{message}</span>
      </h5>
    ),
    description: description || '',
    placement: "topRight",
    duration:10, // Default duration
    style: newNotificationStyle,  // Use dynamic notification style
    className: `${customClassName}`, // Add custom class name
    icon: icon || (type === 'success' ? 
      <i className="anticon anticon-check-circle" style={{ color: 'black' }}></i> : 
      <i className="anticon anticon-close-circle" style={{ color: 'black' }}></i>
    ),
  };

  // Display the notification
  const showNotification = () => {
    if (type === 'success') {
      notification.success(notificationConfig);
    } else if (type === 'error') {
      notification.error(notificationConfig);
    } else if (type === 'info') {
      notification.info(notificationConfig);
    } else if (type === 'warning') {
      notification.warning(notificationConfig);
    }
  };
  useEffect(() => {
    showNotification();  
  }, []);  

  return null;  
};

export default ToastNotification;
